import { ComponentProps, useEffect, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useExperiments, useExposureEvent } from '@alltrails/experiments';
import PeakFeatureUpsellModal from '@alltrails/upsell/components/UpsellSystem/FeatureUpsell/PeakFeatureUpsellModal';
import headerImageSrc from './heatmaps-upsell-header.avif';
import styles from './HeatmapsUpsellModal.module.scss';

type Props = Pick<ComponentProps<typeof PeakFeatureUpsellModal>, 'isOpen' | 'onCloseRequest' | 'upsellTrigger' | 'trailId'>;

const HeatmapsUpsellModal = (modalProps: Props) => {
  const gifExperiment = useExperiments()['web-disco-rm-heatmap-gif-upsell']?.value;
  const sendGifExposure = useExposureEvent('web-disco-rm-heatmap-gif-upsell');

  const gifHeaderImage = useMemo(() => {
    if (gifExperiment === 'gif-upsell') {
      return (
        <picture className={styles.gifImage}>
          <source media="(prefers-reduced-motion: reduce)" srcSet={headerImageSrc.src} type="image/avif" />
          <img src="https://cdn-assets.alltrails.com/assets/upsell/heatmaps-upsell-header.gif" alt="" />
        </picture>
      );
    }

    return undefined;
  }, [gifExperiment]);

  useEffect(() => {
    if (modalProps.isOpen) {
      sendGifExposure();
    }
  }, [gifExperiment, modalProps.isOpen, sendGifExposure]);

  return (
    <PeakFeatureUpsellModal
      {...modalProps}
      customHeaderImage={gifHeaderImage}
      headerImageSrc={headerImageSrc}
      heading={<FormattedMessage defaultMessage="Get inspiration from trailgoers like you" />}
      promoEligibleHeading={<FormattedMessage defaultMessage="Try Heatmaps and more for free" />}
    />
  );
};

export default HeatmapsUpsellModal;
